import { Action, createFeature, createReducer, on } from '@ngrx/store';

import { HttpRequestStatus } from '@cpm-pr1618003/ng-initializer-lib';
import * as landingPageActions from '../actions/landing-page.actions';
import { LandingPage, initialState } from '../state/landing-page.state';

export const landingPageStoreKey: string = 'landingPage';

export const reducers = (state: LandingPage, action: Action): LandingPage => {
  return LandingPageReducer(state, action);
};

export const LandingPageReducer = createReducer(
  initialState,
  on(landingPageActions.setActiveSignButton, (state, { activeSignButton }) => ({
    ...state,
    activeSignButton,
    isOTPRequested: false,
  })),
  on(landingPageActions.signIn, (state) => ({
    ...state,
    isPasswordUpdated: false,
    signInRequestStatus: HttpRequestStatus.In_progress,
  })),
  on(landingPageActions.signInSuccess, (state, { signInResponse }) => ({
    ...state,
    signInResponse,
    signInRequestStatus: HttpRequestStatus.Success,
  })),
  on(landingPageActions.signUp, (state) => ({
    ...state,
    signUpRequestStatus: HttpRequestStatus.In_progress,
  })),
  on(landingPageActions.signUpSuccess, (state, { signUpResponse }) => ({
    ...state,
    signUpResponse,
    signUpRequestStatus: HttpRequestStatus.Success,
  })),
  on(landingPageActions.resetPassword, (state) => ({
    ...state,
    changePasswordRequestStatus: HttpRequestStatus.In_progress,
  })),
  on(landingPageActions.resetPasswordSuccess, (state) => ({
    ...state,
    isOTPRequested: false,
    isPasswordUpdated: true,
    changePasswordRequestStatus: HttpRequestStatus.Success,
  })),
  on(landingPageActions.resetPasswordError, (state) => ({
    ...state,
    isPasswordUpdated: false,
    changePasswordRequestStatus: HttpRequestStatus.Failed,
  })),
  on(landingPageActions.signInError, (state) => ({
    ...state,
    signInRequestStatus: HttpRequestStatus.Failed,
  })),
  on(landingPageActions.signUpError, (state) => ({
    ...state,
    signUpRequestStatus: HttpRequestStatus.Failed,
  })),
  on(landingPageActions.requestOTP, (state) => ({
    ...state,
    requestOTPRequestStatus: HttpRequestStatus.In_progress,
  })),
  on(landingPageActions.requestOTPSuccess, (state) => ({
    ...state,
    isOTPRequested: true,
    requestOTPRequestStatus: HttpRequestStatus.Success,
  })),
  on(landingPageActions.requestOTPError, (state) => ({
    ...state,
    isOTPRequested: false,
    requestOTPRequestStatus: HttpRequestStatus.Failed,
  })),
  on(landingPageActions.setReactivateKey, (state, { reactivateKey }) => ({
    ...state,
    reactivateKey,
    reactivateAccountErrorMessage: null,
  })),
  on(landingPageActions.reactivateAccount, (state) => ({
    ...state,
    reactivateAccountRequestStatus: HttpRequestStatus.In_progress,
    reactivateAccountErrorMessage: null,
  })),
  on(landingPageActions.reactivateAccountSuccess, (state, { response }) => ({
    ...state,
    reactivateAccountResponse: response,
    reactivateAccountRequestStatus: HttpRequestStatus.Success,
    reactivateAccountErrorMessage: null,
  })),
  on(landingPageActions.reactivateAccountError, (state, { errorMessage }) => ({
    ...state,
    reactivateAccountRequestStatus: HttpRequestStatus.Failed,
    reactivateAccountErrorMessage: errorMessage,
  })),
  on(landingPageActions.resetReactivateAccountState, (state) => ({
    ...state,
    reactivateKey: null,
    reactivateAccountResponse: null,
    reactivateAccountRequestStatus: HttpRequestStatus.Idle,
    reactivateAccountErrorMessage: null,
  })),
  on(landingPageActions.submitContactUs, (state) => ({
    ...state,
    contactUsRequestStatus: HttpRequestStatus.In_progress,
  })),
  on(
    landingPageActions.submitContactUsSuccess,
    (state, { contactUsResponse }) => ({
      ...state,
      contactUsResponse,
      contactUsRequestStatus: HttpRequestStatus.Success,
    }),
  ),
  on(landingPageActions.submitContactUsError, (state) => ({
    ...state,
    contactUsRequestStatus: HttpRequestStatus.Failed,
  })),
  on(landingPageActions.resetContactUsRequestStatus, (state) => ({
    ...state,
    contactUsRequestStatus: HttpRequestStatus.Idle,
  })),
  on(landingPageActions.resetSignInRequestStatus, (state) => ({
    ...state,
    signInRequestStatus: HttpRequestStatus.Idle,
  })),
  on(landingPageActions.resetSignUpRequestStatus, (state) => ({
    ...state,
    signUpRequestStatus: HttpRequestStatus.Idle,
  })),
  on(landingPageActions.resetRequestOTPRequestStatus, (state) => ({
    ...state,
    requestOTPRequestStatus: HttpRequestStatus.Idle,
  })),
  on(landingPageActions.resetChangePasswordRequestStatus, (state) => ({
    ...state,
    changePasswordRequestStatus: HttpRequestStatus.Idle,
  })),
);

export const landingPageFeature = createFeature({
  name: landingPageStoreKey,
  reducer: reducers,
});
